let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9pzF3")).then(() => parcelRequire('8oMCy'));